import { render, staticRenderFns } from "./detail-partial-human-resources.vue?vue&type=template&id=5168d373"
import script from "./detail-partial-human-resources.vue?vue&type=script&lang=js"
export * from "./detail-partial-human-resources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports